const STATE_VERSION = process.env.REACT_APP_STATE_VERSION || '1';
const STATE_VERSION_KEY = 'state_version';

export const loadState = () => {
    try {
        /*const storedVersion = localStorage.getItem(STATE_VERSION_KEY);
        if (storedVersion !== STATE_VERSION) {
            localStorage.removeItem('state');
            localStorage.removeItem(STATE_VERSION_KEY);
            return undefined;
        }*/
        const serializedState = localStorage.getItem('state');
        if(serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch(err) {
        return undefined;
    }
}

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
        localStorage.setItem(STATE_VERSION_KEY, STATE_VERSION);
    }
    catch(err) {

    }
}